import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { SelfManagerEvaluationReportComponent } from './self-manager-evaluation.component';
import { ViewGoalsModule } from 'src/app/dashboard/goals-progress/view-goals/view-goals.module';

@NgModule({
  declarations: [
    SelfManagerEvaluationReportComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule,
    ViewGoalsModule
  ],
  exports: [
    SelfManagerEvaluationReportComponent
  ]
})
export class SelfManagerEvaluationReportModule { }
